import { useTranslation } from 'react-i18next';
import { PGSectionNumber } from '~/components/Paperwork/providerGroups/constants';
import { SectionNumber } from '~/components/Paperwork/constants';
import { SectionNumberObj } from '~/components/Paperwork/interfaces';
import { useGetSectionsProgress } from '~/components/Paperwork/hooks';
import { PaperworkState } from '~/ducks/paperwork';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';

interface TranslatedNames {
  navTitle: string;
  navSubtitle?: string;
}

const PGSectionDisplayNumber = new Map([
  [PGSectionNumber.Patient, 1],
  [PGSectionNumber.Medical, 2],
  [PGSectionNumber.LifestyleFactors, 3],
  [PGSectionNumber.HealthcareContacts, 4],
  [PGSectionNumber.VerificationAndReview, 5],
]);

export const useTranslationNavBar = <Sect extends SectionNumber | PGSectionNumber>(
  sectionValue: Sect,
  section: SectionNumberObj<Sect>,
  paperwork: PaperworkState
): TranslatedNames => {
  const { t } = useTranslation(['providerGroupPaperwork', 'paperwork']);
  const bookingId = usePaperworkContextBookingId();

  const { sectionNumber, totalSections } = useGetSectionsProgress(
    paperwork,
    sectionValue,
    section,
    bookingId
  );
  let navTitle = t('paperwork:common.navTitle');
  let navSubtitle;
  if (
    sectionValue &&
    sectionValue !== PGSectionNumber.Start &&
    sectionValue !== SectionNumber.Start
  ) {
    navTitle =
      section === PGSectionNumber
        ? t(`providerGroupPaperwork:${sectionValue}.sectionTitle` as any)
        : t(`paperwork:${sectionValue}.sectionTitle` as any);
    navSubtitle =
      section === PGSectionNumber
        ? t('providerGroupPaperwork:common.sectionSubtitle' as any, {
            CURRENT_SECTION: PGSectionDisplayNumber.get(sectionValue as PGSectionNumber),
            TOTAL_SECTIONS: PGSectionDisplayNumber.size,
          })
        : t('paperwork:common.sectionSubtitle' as any, {
            CURRENT_SECTION: sectionNumber,
            TOTAL_SECTIONS: totalSections,
          });
  }
  return { navTitle, navSubtitle };
};
